import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { genericTracingTransformer } from '@shared/tracking/tracing/generic-tracing-transformer';
import { OrderHeader, OrderItem } from '@usf/ngrx-order';
import { Product } from '../../../../../shared/models/product.model';
import { editOrderButtonClick } from './order-submitted-models/order-submitted-edit-order-button-click.trace';
import { ORDER_SUBMTITED_TRACING_ACTIONS } from './order-submitted-tracing.actions';
import { SharedTrackingService } from 'src/app/shared/services/analytics/shared-tracking.service';
import { OrderSubmittedTracingMessages } from './order-submitted-tracing.constants';
import { Tracking } from '@panamax/app-state';
import { FileEntity } from '@shared/models/file-entity';
@Injectable({
  providedIn: 'root',
})
export class OrderSubmittedTracingService {
  constructor(private store: Store) {}

  traceEditOrderButtonClick(orderHeader: OrderHeader) {
    let tracking = JSON.parse(JSON.stringify(editOrderButtonClick));
    tracking.tracing.data.isStartOfTrace = true;
    tracking.tracing.data.isEndOfTrace = true;
    tracking.tracing.data.attributes.order.orderId = orderHeader.orderId;
    tracking.tracing.data.attributes.order.origOrderId = !!orderHeader.origOrderId
      ? orderHeader.origOrderId
      : '';
    tracking.tracing.data.attributes.order.origSplitOrderId = !!orderHeader.origSplitOrderId
      ? orderHeader.origSplitOrderId
      : '';
    tracking.tracing.data.attributes.order.requestedDeliveryDate =
      orderHeader.requestedDeliveryDate;
    tracking.tracing.data.attributes.order.confirmedDeliveryDate =
      orderHeader.confirmedDeliveryDate;
    tracking.tracing.data.attributes.order.totalAmount = orderHeader.totalPrice;
    tracking.tracing.data.attributes.order.tandemOrderNumber =
      orderHeader.tandemOrderNumber;
    tracking.tracing.transformFunc = genericTracingTransformer;

    this.store.dispatch(
      ORDER_SUBMTITED_TRACING_ACTIONS.traceEditOrderButtonClick({ tracking }),
    );
  }

  submittedOrderDetailsPageLoad = (
    orderHeader: OrderHeader,
    orderItems: OrderItem[],
    products: Map<number, Product>,
  ) => {
    const {
      orderId,
      origSplitOrderId,
      origOrderId,
      requestedDeliveryDate,
      confirmedDeliveryDate,
      divisionNumber,
      tandemOrderNumber,
      totalDollars,
    } = orderHeader;

    const tracking: Tracking = {
      tracing: {
        data: {
          traceContext: OrderSubmittedTracingMessages.capability,
          isEndOfTrace: true,
          isStartOfTrace: true,
          attributes: {
            order: {
              orderId,
              origOrderId: !!origOrderId ? origOrderId : '',
              origSplitOrderId: !!origSplitOrderId ? origSplitOrderId : '',
              totalAmount: totalDollars,
              tandemOrderNumber,
              divisionNumber,
              requestedDeliveryDate,
              confirmedDeliveryDate,
            },
            products: orderItems
              ? SharedTrackingService.tracingProductData(orderItems, products)
              : [],
            event: OrderSubmittedTracingMessages.submittedOrderDetailsPageLoad,
          },
        },
        transformFunc: genericTracingTransformer,
      },
    };
    this.store.dispatch(
      ORDER_SUBMTITED_TRACING_ACTIONS.submittedOrderDetails({ tracking }),
    );
  };

  traceSubmittedOrderDownload = (
    orderHeader: OrderHeader,
    fileEntity: FileEntity,
  ) => {
    const {
      orderId,
      origSplitOrderId,
      origOrderId,
      requestedDeliveryDate,
      confirmedDeliveryDate,
      tandemOrderNumber,
      totalDollars,
    } = orderHeader;

    const tracking: Tracking = {
      tracing: {
        data: {
          traceContext: OrderSubmittedTracingMessages.capability,
          isEndOfTrace: true,
          isStartOfTrace: true,
          attributes: {
            order: {
              orderId,
              origSplitOrderId: !!origSplitOrderId ? origSplitOrderId : '',
              origOrderId: !!origOrderId ? origOrderId : '',
              totalAmount: totalDollars,
              requestedDeliveryDate,
              confirmedDeliveryDate,
              tandemOrderNumber,
              fileFormat: fileEntity.fileExtension,
            },
            event: OrderSubmittedTracingMessages.downloadOrder,
          },
        },
        transformFunc: genericTracingTransformer,
      },
    };
    this.store.dispatch(
      ORDER_SUBMTITED_TRACING_ACTIONS.downloadOrder({ tracking }),
    );
  };
}
